const $ = require('jquery');

window.$ = window.jQuery = $;

import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';

//sweetalert2
window.Swal = require('sweetalert2');

window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
require('jquery-easy-loading/dist/jquery.loading.min');
require('jquery-validation/dist/jquery.validate.min');
try {
    require('jquery-validation/dist/localization/messages_' + $selectedLanguage + '.min');
} catch (err) {
}

jQuery.validator.setDefaults({
    ignore: ":hidden:not(select)",
    errorElement: "div",
    errorClass: "invalid-feedback",
    highlight: function (element) {
        $(element).closest(".form-control").addClass("is-invalid");
    },
    unhighlight: function (element) {
        $(element).closest(".form-control").removeClass("is-invalid");
    },
    errorPlacement: function (error, element) {
        if (element.parent(".input-group").length || element.prop("type") === "checkbox" || element.prop("type") === "radio") {
            error.insertAfter(element.parent());
        } else {
            error.insertAfter(element);
        }
    }
});

$(document).ready(function () {
    $('.form-validate').validate();
    $('.form-validate2').validate();

    $.fn.datepicker.dates['es'] = {
        days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
        daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
        daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        today: "Hoy",
        clear: "Borrar",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };
    $('.datepicker').datepicker({
        format: "dd/mm/yyyy",
        weekStart: 1,
        language: "es",
        autoclose: true,
        todayHighlight: true,
        endDate: "0d",
        maxViewMode: 2
    });

    $(document.body).on('click', '.modal-assistant', function (e) {
        e.preventDefault();
        modalLoading(true);
        let url = $(this).attr('data-url');
        $.ajax({
            method: 'GET',
            url: url
        }).done(function (data) {
            modalLoading(false);
            $('<div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true"><div class="modal-dialog modal-xl"><div class="modal-content"> ' + data + '</div></div></div>').modal('show');
        }).fail(function () {
            modalLoading(false);
            alert('Error inesperado. Recargue la página y vuelva a intentarlo.');
        });
    });

    $('#chooseLanguage').on('change', function () {
        console.log('12345');
        window.location.href = '/' + $(this).val();
    });
});

function modalLoading(valid) {
    if (valid) {
        $('body').loading({
            theme: 'dark'
        });
    } else {
        $('body').loading('stop');
    }
}

$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $('.scroll-to-top').fadeIn();
    } else {
        $('.scroll-to-top').fadeOut();
    }
});
$('.scroll-to-top').click(function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 300);
});

//reload captcha (posibilidad de tener 2 captchas en la misma página)
/*$('#reload-assistant').click(function () {
    $.ajax({
        type: 'GET',
        url: 'reload-captcha',
        success:function (data){
            $('.captcha-assistant span').html(data.captcha);
        }
    });
});

$('#reload-company').click(function () {
    $.ajax({
        type: 'GET',
        url: 'reload-captcha',
        success:function (data){
            $('.captcha-company span').html(data.captcha);
        }
    });
});

$('#assistants-tab').click(function () {
    $.ajax({
        type: 'GET',
        url: 'reload-captcha',
        success:function (data){
            $('.captcha-assistant span').html(data.captcha);
        }
    });
});
$('#companies-tab').click(function () {
    $.ajax({
        type: 'GET',
        url: 'reload-captcha',
        success:function (data){
            $('.captcha-company span').html(data.captcha);
        }
    });
});*/


//hacer que todos los enlaces con almohadilla desplacen 100px más abajo y que no aparezca en la url la #
/*document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        if (!anchor.hasAttribute('data-fancybox')){
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const offset = 100; //el valor debe de ser el de la clase header-spacer
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = targetElement.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    });
});*/


//Menu
const menuBtn = document.querySelector('.icon-menu');
const menuBtnIcon = document.querySelector('.icon-menu i');
const mainMenuWrapper = document.querySelector('.mainmenu__wrapper');
const mainMenu = document.querySelector('.mainMenu');

/*menuBtn.addEventListener('click', () => {
    menuBtn.classList.toggle('active');
    menuBtnIcon.classList.toggle('active');
    if (menuBtnIcon.classList.contains('active')){
        menuBtnIcon.classList.add('fa-times');
        menuBtnIcon.classList.remove('fa-grip-lines');
    }else {
        menuBtnIcon.classList.remove('fa-times');
        menuBtnIcon.classList.add('fa-grip-lines');
    }
    mainMenuWrapper.classList.toggle('active');
    mainMenu.classList.toggle('active');
});

document.addEventListener('click', function(event) {
    if (!mainMenu.contains(event.target) && !menuBtn.contains(event.target)){
        menuBtn.classList.remove("active");
        menuBtnIcon.classList.remove("active");
        menuBtnIcon.classList.remove('fa-times');
        menuBtnIcon.classList.add('fa-grip-lines');
        mainMenu.classList.remove("active");
        mainMenuWrapper.classList.remove("active");
    }
});

//hacer que la clase active se ponga en el enlace que quiero según el scroll
const menuLinks = document.querySelectorAll('.menu .item a[href^="#"]');

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            const id = entry.target.getAttribute("id");
            const menuLink = document.querySelector(`.menu .item a[href="#${id}"]`);

            if (entry.isIntersecting){
                document.querySelector(".menu .item a.active").classList.remove("active");
                menuLink.classList.add("active");
            }
        });
    },
    { rootMargin: "-30% 0px -70% 0px"}
);

menuLinks.forEach((menuLink) => {
    menuLink.addEventListener("click", function () {
        mainMenuWrapper.classList.remove("active");
        mainMenu.classList.remove("active");
        menuBtn.classList.remove('active');
        menuBtnIcon.classList.remove('active');
        menuBtnIcon.classList.remove('fa-times');
        menuBtnIcon.classList.add('fa-grip-lines');
    });

    const hash = menuLink.getAttribute("href");
    const target = document.querySelector(hash);
    if (target) {
        observer.observe(target);
    }
});*/

//añadir el fondo de blanco en el nav principal de la web en la home al hacer scroll
$(document).ready(function(){
    // Menú responsive Feria FP Pyme 2026
    const $btnMenu = $('.btn__menu');
    const $menuResponsive = $('.main__menu-responsive');
    const $menuLinks = $('.menu__responsive-item, .main__menu-responsive .btn__feria, .menu__responsive-legal a');

    $btnMenu.on('click', function() {
        $(this).toggleClass('active');
        $menuResponsive.toggleClass('active');

        if ($(this).hasClass('active')) {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', '');
        }
    });

    // Manejo de anclajes con scroll suave y offset de 100px
    $('a[href^="#"]').on('click', function(e) {
        const href = $(this).attr('href');

        // Ignorar si es solo # o si es un trigger de modal de bootstrap
        if (href === '#' || $(this).attr('data-bs-toggle') === 'modal') {
            return;
        }

        const $target = $(href);
        if ($target.length) {
            e.preventDefault();

            // Cerrar menú responsive si está abierto
            $btnMenu.removeClass('active');
            $menuResponsive.removeClass('active');
            $('body').css('overflow', '');

            const offset = 100;
            const targetPosition = $target.offset().top - offset;

            $('html, body').animate({
                scrollTop: targetPosition
            }, 200);
        }
    });

    $(window).scroll(function(){
        var scroll = $(window).scrollTop();
        if (scroll > 150) {
            $(".main__menu").addClass('navbar-scrolled');
        }

        else{
            $(".main__menu").removeClass('navbar-scrolled');
        }
    })
});

//desaparecer menu responsive (del área privada) del todo cuando estoy debajo del todo
/*$(document).ready(function(){
    $(window).scroll(function(){
        var scroll = $(document).height() - $(window).scrollTop() - $(window).height();
        if (scroll < 50) {
            $(".menu__private-area-responsive").addClass('hide');
        }

        else{
            $(".menu__private-area-responsive").removeClass('hide');
        }
    })
});*/

$(document).ready(function(){
    $(window).on("scroll resize", function(){
        var scrollTop = window.scrollY || window.pageYOffset; // Detectar el scroll vertical actual
        var windowHeight = window.innerHeight; // Altura visible de la ventana
        var documentHeight = $(document).height(); // Altura total del documento

        // Calcular cuánto falta para el final de la página
        var scroll = documentHeight - scrollTop - windowHeight;

        if (scroll < 50) {
            $(".menu__private-area-responsive").addClass('d-none');
        } else {
            $(".menu__private-area-responsive").removeClass('d-none');
        }
    });
});

